import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { logout } from './slices/authSlice';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';

export default function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);
  const storedToken = userInfo?.token;

  useEffect(() => {
    if (storedToken) {
      const { exp } = JSON.parse(atob(storedToken.split('.')[1]));

      const expirationDate = new Date(exp * 1000);
      console.log('Token expires at: ', expirationDate.toLocaleString());

      const currentTime = Date.now() / 1000;
      const expiresIn = exp - currentTime;

      const timeout = setTimeout(() => {
        logoutHandler();
        toast.warning('Session expired. You have been logged out.');
        // console.log('Session expired. You have been logged out.');
      }, expiresIn * 1000);

      // Reset timeout on user activity
      const resetTimeout = () => {
        clearTimeout(timeout);
        const remainingTime = exp - Date.now() / 1000;
        setTimeout(logoutHandler, remainingTime * 1000);
      };

      // Attach event listeners for user activity
      document.addEventListener('mousemove', resetTimeout);
      document.addEventListener('keypress', resetTimeout);

      // Return cleanup function
      return () => {
        // Clean up event listeners
        document.removeEventListener('mousemove', resetTimeout);
        document.removeEventListener('keypress', resetTimeout);
        clearTimeout(timeout);
      };
    }

    return () => { };
  }, [storedToken]);


  const logoutHandler = async () => {
    try {
      // Dispatch logout action to Redux store
      dispatch(logout());
      navigate('/');
    } catch (err) {
      console.log(err);
      toast.warning('Session expired. You have been logged out');
    }
  };

  return (
    <ThemeProvider>
      <ScrollToTop />
      <ToastContainer />
      <Router />
    </ThemeProvider>
  );
}
